// H13 (Ticket 4b-2): nivel de voz del CLIENTE -- funciones PURAS (nada de Web Audio real aquí, para poder
// probarlas sin un navegador). Quien SÍ tiene audio real (pista remota de SIP.js) usa rmsLevelFromBytes +
// smoothLevel con un AnalyserNode (ver hooks/useAudioLevel.js); quien no tiene audio (observador) usa
// useDiscreteVoiceLevel a partir de la transcripción ya disponible.

// RMS normalizado 0..1 a partir de AnalyserNode.getByteTimeDomainData() (bytes 0..255, centrados en 128).
export function rmsLevelFromBytes(bytes) {
  if (!bytes || !bytes.length) return 0;
  let sum = 0;
  for (let i = 0; i < bytes.length; i++) {
    const v = (bytes[i] - 128) / 128;
    sum += v * v;
  }
  const rms = Math.sqrt(sum / bytes.length);
  // *4: la voz normal rara vez usa todo el rango de muestreo; sin esto casi nunca se vería una barra llena.
  return Math.max(0, Math.min(1, rms * 4));
}

// Sube rápido (ataque) y baja más despacio (release) para que no "tiemble" entre frames ni se quede pegada
// en silencio esperando el próximo pico. `dt` en segundos (tiempo real entre muestras, no fijo).
export function smoothLevel(prev, target, dt = 1 / 30, attackPerSec = 18, releasePerSec = 6) {
  const p = Number.isFinite(prev) ? prev : 0;
  const t = Number.isFinite(target) ? target : 0;
  const rate = t > p ? attackPerSec : releasePerSec;
  const k = 1 - Math.exp(-rate * Math.max(0, dt));
  return p + (t - p) * k;
}

// Alturas de las 6 barras a partir de un nivel 0..1: un patrón FIJO de pesos (no al azar, para que sea
// determinista y se pueda probar) escalado por el nivel, con un mínimo "en reposo" (nunca a 0 en seco).
export const BAR_WEIGHTS = [0.55, 1, 1.35, 0.8, 1.1, 0.6];
export const BAR_MIN_PX = 3;
export const BAR_MAX_PX = 26;
export function levelToBarHeights(level) {
  const lv = Math.max(0, Math.min(1, Number.isFinite(level) ? level : 0));
  const maxW = Math.max(...BAR_WEIGHTS);
  return BAR_WEIGHTS.map((w) => Math.round(BAR_MIN_PX + (BAR_MAX_PX - BAR_MIN_PX) * lv * (w / maxW)));
}
